export const textAboutMe = [
    `A skilled and versatile frontend developer with solid experience in creating engaging and responsive web applications that deliver impactful user experiences.`,
    `Proficient in a wide range of technologies, including React, Next.js Vanilla.js and more. With a background in frontend development, I've successfully delivered various projects, ranging from chat applications to business websites and e-commerce integrations.`,
    `My expertise includes frontend development, backend integration, optimization for performance, and collaboration with cross-functional teams. Committed to continuous learning, I've completed numerous online courses and obtained certifications to stay updated with the latest technologies and industry standards.`,
    `Fluent in Ukrainian and possessing strong intermediate English proficiency, I thrive in multicultural environments and excel in both independent and collaborative settings.`,
];
export const textAboutMeUA = [
    `Досвідчений і різносторонній фронтенд-розробник із впевненим досвідом у створенні привабливих та адаптивних веб-застосунків, що забезпечують ефективну взаємодію з користувачами.`,
    `Володію великим спектром технологій, включаючи React, Next.js, Ваніла.js та багато інших. З міцними знаннями у розробці фронтенду, я успішно реалізував різноманітні проекти, від чат-додатків до корпоративних веб-сайтів та інтеграцій електронної комерції.`,
    `Мої навички включають розробку фронтенду, інтеграцію з бекендом, оптимізацію для підвищення продуктивності та співпрацю з міжфункціональними командами. Завдяки постійному навчанню, я успішно завершив численні онлайн-курси та отримав сертифікати, щоб залишатися в курсі останніх технологій та стандартів галузі.`,
    `Володію рідною українською мовою та маю сильні середні знання англійської, прекрасно вписуюся в багатокультурне середовище та успішно працюю як самостійно, так і у команді.`,
];

export const about = (
    <>
        <span>About</span> me
    </>
);
export const aboutUA = (
    <>
        <span>Про</span> мене
    </>
);

export const contactTitle = (
    <>
        <span>Get</span> in touch
    </>
);
export const contactTitleUA = (
    <>
        <span>Будьмо</span> на зв'язку
    </>
);

export const ageExcept = 'age';
export const ageExceptUA = 'вік';

export const residenceExcept = 'residence';
export const residenceExceptUA = 'проживання';

export const languagesExcept = 'languages';
export const languagesExceptUA = 'мови';

export const freelanceExcept = 'freelance';
export const freelanceExceptUA = 'Фріланс';

function getAge(birthday) {
    const today = new Date();
    const year = birthday.getFullYear();
    const month = birthday.getMonth();
    const day = birthday.getDate();
    let age = today.getFullYear() - year;
    if (
        today.getMonth() < month ||
        (today.getMonth() === month && today.getDate() < day)
    ) {
        age--;
    }

    return age;
}

const birthday = new Date('1990-08-12');
const myAge = getAge(birthday);

export const myBioInfo = [
    {
        key: 'age',
        value: myAge,
    },
    {
        key: 'email',
        value: 'oleg.m.dub@gmail.com',
    },
    {
        key: 'phone',
        value: '+38(096)682-39-64',
    },
    {
        key: 'address',
        value: 'Lviv, Ukraine',
    },
    {
        key: 'residence',
        value: 'Ukraine',
    },
    {
        key: 'freelance',
        value: 'Available',
    },
    {
        key: 'languages',
        value: 'English, Ukrainian',
    },
];
export const myBioInfoUA = [
    {
        key: 'вік',
        value: myAge,
    },
    {
        key: 'пошта',
        value: 'oleg.m.dub@gmail.com',
    },
    {
        key: 'тел.',
        value: '+38(096)682-39-64',
    },
    {
        key: 'адреса',
        value: 'Львів, Україна',
    },
    {
        key: 'проживання',
        value: 'Україна',
    },
    {
        key: 'Фріланс',
        value: 'Можливий',
    },
    {
        key: 'мови',
        value: 'Англійська, Українська',
    },
];
